import { render } from "./Products.vue?vue&type=template&id=875fdaa4"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
script.render = render

export default script